import React, {useState, useEffect} from 'react';
import Gallery from 'react-grid-gallery';
import { imageURL, thumbParams, config } from '../../apis/cloudinary';
import { Button, Header, Divider, Grid } from 'semantic-ui-react';

const PictureList = ({pictureData, admin, handleDeleteSelected}) => {
    const [pictures, setPictures] = useState([]);

    useEffect(() => {
        setPictures(pictureData.map(picture => {
            return {
                publicId: picture.public_id,
                src: `${imageURL}/q_auto:good/${picture.public_id}`,
                thumbnail: `${imageURL}/${thumbParams}/${picture.public_id}`,
                thumbnailWidth: config.thumbWidth,
                thumbnailHeight: config.thumbHeight,
                caption: picture.context && picture.context.custom ? picture.context.custom.alt : '',
                isSelected: false
            }
        }));
    }, [pictureData]);

    const onSelectedPicture = (index, image) => {
        const pics = [...pictures];
        pics[index].isSelected = !pics[index].isSelected;
        setPictures(pics);
    };

    const getSelected = () => {
        return pictures.filter(picture => picture.isSelected);;
    };
        
    if (pictureData.length > 0) {        
        return (
            <Grid columns={1}>
                <Grid.Row>
                    <Grid.Column>
                        <Gallery 
                            images={pictures} 
                            showLightboxThumbnails={true} 
                            enableImageSelection={admin||false}
                            onSelectImage={onSelectedPicture}
                        />
                    </Grid.Column>
                </Grid.Row>
                { admin && 
                    <Grid.Row>
                        <Grid.Column>
                            <Divider/>
                            <Button 
                                onClick={()=> handleDeleteSelected(getSelected())} 
                                disabled={getSelected().length < 1 }
                                color="red"
                            >
                                Delete Selected
                            </Button> 
                        </Grid.Column>
                    </Grid.Row>
                }
            </Grid>
        );
    } else {
        return <Header as="h4">No pictures in this category</Header>
    }
};

export default PictureList;